import { Box, Divider, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import PermissionsGate from "../../privateRoute/permissionsGate";
import { PLATFORM_PERMISSIONS } from "../../../shared/models/abacConfig";
type Props = {
  facility: any;
  handleUpdate: (facility: any) => void;
};
const FacilityBox = ({ facility, handleUpdate }: Props) => {
  const [openAction, setOpenAction] = useState(false);
  const handleOpenAction = () => {
    setOpenAction(!openAction);
  };
  const handleUpdateClicked = () => {
    const facilityDetails = {
      ...facility,
    }
    handleUpdate(facilityDetails)
  }
  return (
    <Box>
      <Box className="facilityBoxHeader">
        <Typography className="facilityName">{facility?.facilityName}</Typography>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: { xs: "5em", md: "5.5em" },
                  justifyContent: "space-around",
                }}
                onClick={handleOpenAction}
              >
                <Typography
                  sx={{
                    cursor: "pointer",
                    color: "#22438C",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  Action
                </Typography>
                <KeyboardArrowDownIcon
                  sx={{ color: "#22438C", cursor: "pointer" }}
                />
              </Box>
              <Box
                sx={{
                  display: openAction ? "block" : "none",
                  position: "absolute",
                  width: "140%",
                  top: "35px",
                  boxShadow: "-1px 4px 8px 0px #00000040",
                  right: "12px",
                  backgroundColor: "#fff"
                }}
              >
                <PermissionsGate permissions={[PLATFORM_PERMISSIONS.FACILITY_UPDATE, PLATFORM_PERMISSIONS.FACILITY_ADMIN]}>

                  <MenuItem
                    value={"Edit"}
                    className="facilityMenuItems"
                    onClick={handleUpdateClicked}
                  >
                    <ModeEditOutlineOutlinedIcon /> <Typography>Edit</Typography>
                  </MenuItem>
                </PermissionsGate>
                <Divider variant="middle"
                  sx={{
                    marginTop: "2px !important",
                    marginBottom: "2px !important",
                  }}
                />
              </Box>
            </Box>
      </Box>
      <Box className="facilityBoxContent">
        <Box className="facilityDetails">
          <Typography className="facilityDetailTitle">Store Type</Typography>
          <Typography className="facilityDetailContent">
            {facility?.facilityTypeId}
          </Typography>
        </Box>
        {/* <Box className="facilityDetails">
          <Typography className="facilityDetailTitle">Size</Typography>
          <Typography className="facilityDetailContent">{facility?.facilitySize}</Typography>
        </Box> */}
        <Box className="facilityDetails">
          <Typography className="facilityDetailTitle">Description</Typography>
          <Typography className="facilityDetailContent">{facility?.description}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FacilityBox;
